import Persons from "./persons/component";
import Images from "./images/component";

const AboutUs = () => {
  return (
    <div>
      <h2>Steckbriefe</h2>
      <Persons/>
      
      <h2>Auf der Bühne</h2>
      <Images/>
    </div>
  );
};

export default AboutUs;
